module.exports = __webpack_public_path__ + "assets/img/23_32_big.0e190a87.jpg";